const sizeMap = {
  sm: 'w-4 h-4 border-2',
  md: 'w-8 h-8 border-2',
  lg: 'w-12 h-12 border-4',
};

const Spinner = ({ size = 'md', label = 'Loading', className = '' }) => (
  <span
    role="status"
    aria-label={label}
    className={`inline-block ${sizeMap[size] || sizeMap.md} border-gray-200 border-t-orange-600 rounded-full animate-spin ${className}`}
  />
);

export const FullPageSpinner = ({ label = 'Loading' }) => (
  <div
    className="w-full mx-auto px-4 py-16 flex flex-col items-center justify-center"
    role="status"
    aria-live="polite"
  >
    <Spinner size="lg" label={label} />
    <p className="text-sm text-black mt-3">{label}…</p>
  </div>
);

export default Spinner;
